import React from "react";
import {
  displayTransferRecipient,
  displayTransferStatus,
} from "../../utils/utils";
import { monthDateYear } from "../../utils/utils";

const TERMINAL_NEGATIVE = ["FAILED", "DECLINED", "CANCELLED", "EXPIRED"];

const arrowUp = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="12" y1="20" x2="12" y2="6" />
    <polyline points="6 12 12 6 18 12" />
  </svg>
);

const arrowDown = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="12" y1="4" x2="12" y2="18" />
    <polyline points="6 12 12 18 18 12" />
  </svg>
);

const dash = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <line x1="6" y1="12" x2="18" y2="12" />
  </svg>
);

const clock = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="8" />
    <polyline points="12 7 12 12 15 14" />
  </svg>
);

const OutgoingTransfer = ({ outgoing, handleLinkClick, isScheduled }) => {
  const isRequestForPay = outgoing.originated_as_rfp === true;
  const isTerminalNegative = TERMINAL_NEGATIVE.includes(outgoing.status);
  const isScheduledRow = isScheduled && outgoing.next_occurrence;

  // Avatar: accent arrow-up for money going out, neutral arrow-down for a
  // request the requester has been paid on, muted dash for terminal states.
  const avatar = () => {
    if (isTerminalNegative) {
      return <span className="np-avatar np-avatar-muted">{dash}</span>;
    }
    if (isScheduledRow) {
      return <span className="np-avatar">{clock}</span>;
    }
    if (isRequestForPay) {
      return <span className="np-avatar">{arrowDown}</span>;
    }
    return <span className="np-avatar np-avatar-accent">{arrowUp}</span>;
  };

  return (
    // data-cy is a stable hook for E2E: lets a spec open the exact transfer
    // it created instead of the newest row (cypress/e2e/constants.js).
    <li
      className="np-list-row"
      data-cy={`transfer_row_${outgoing.id}`}
      onClick={(event) => handleLinkClick(event)}
    >
      {outgoing.recipient && (
        <>
          {avatar()}
          <div className="np-list-body">
            <div className="np-list-title" data-cy="recipient_value">
              {displayTransferRecipient(outgoing.recipient, true, outgoing)}
            </div>
            <div className="np-list-sub">
              {isScheduled ? (
                <>
                  {outgoing.comment}
                  <div>
                    {outgoing.repeat_frequency.charAt(0).toUpperCase() +
                      outgoing.repeat_frequency.substr(1).toLowerCase()}
                    <span style={{ margin: "0 3px" }}> | </span>Next:{" "}
                    {monthDateYear(
                      new Date(
                        `${outgoing.next_occurrence?.split("T")[0]}T00:00:00`
                      )
                    )}
                  </div>
                </>
              ) : (
                displayTransferStatus(outgoing)
              )}
            </div>
          </div>
          <div
            className={
              isTerminalNegative
                ? "np-list-amount np-list-amount-muted"
                : "np-list-amount"
            }
          >
            {isRequestForPay
              ? outgoing.status === "SUCCEEDED"
                ? "+"
                : ""
              : "-"}
            ${parseFloat(outgoing.amount.value).toFixed(2)}
          </div>
        </>
      )}
    </li>
  );
};

export default OutgoingTransfer;
